import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { COMMON_IMPORTS } from 'app/common-imports';
import { DealSelectComponent } from 'app/modules/borrower/components/borrower-details/workflow/stipulations/deal-select/deal-select.component';
import { DocumentModule } from 'app/modules/borrower/components/document/module';
import { DocumentStipComponent } from 'app/modules/borrower/components/borrower-details/workflow/stipulations/document-stip/document-stip.component';
import { FileUploadModule } from 'ng2-file-upload';
import { LenderStipsComponent } from 'app/modules/borrower/components/borrower-details/workflow/stipulations/lender-stips/lender-stips.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { RequestBuilderComponent } from 'app/modules/borrower/components/borrower-details/workflow/stipulations/request-builder/request-builder.component';
import { SharedModule } from 'app/shared-module';
import { StipTemplateComponent } from 'app/modules/borrower/components/borrower-details/workflow/stipulations/stip-template/stip-template.component';
import { StipulationsComponent } from 'app/modules/borrower/components/borrower-details/workflow/stipulations/stipulations.component';
import { TextStipComponent } from 'app/modules/borrower/components/borrower-details/workflow/stipulations/text-stip/text-stip.component';
import { CollapsibleContainerModule } from 'ng2-app/borrower-fd/borrower-fd-sidebar/collapsible-container/collapsible-container.module';

@NgModule({
    declarations: [
        DealSelectComponent,
        DocumentStipComponent,
        LenderStipsComponent,
        RequestBuilderComponent,
        StipTemplateComponent,
        StipulationsComponent,
        TextStipComponent,
    ],
    exports: [
        StipulationsComponent,
    ],
    imports: [
        BsDropdownModule.forRoot(),
        CollapsibleContainerModule,
        COMMON_IMPORTS,
        DocumentModule,
        FileUploadModule,
        MatButtonModule,
        MatIconModule,
        SharedModule,
    ]
})
export class StipulationsModule { }
